import React from "react";
import { View, StyleSheet } from "react-native";
import { TableBodyProps } from "./types";
import { TableRow } from "./TableRow";

export function TableBody<T>({
  data,
  columns,
  keyExtractor,
  onRowPress,
  rowActions,
  minActionSlots,
  onEdit,
  canEdit,
  onDelete,
  canDelete,
  rowStyle,
  selectable,
  selectedKeys,
  onToggleSelect,
  showTooltipWhileEditing,
}: TableBodyProps<T>) {
  return (
    <View style={styles.body}>
      {data.map((row, index) => {
        const key = keyExtractor(row, index);
        const computedRowStyle = typeof rowStyle === "function" ? rowStyle(row, index) : rowStyle;
        // Evaluate canEdit/canDelete for this row if they're functions
        const rowCanEdit = typeof canEdit === "function" ? canEdit(row) : canEdit;
        const rowCanDelete = typeof canDelete === "function" ? canDelete(row) : canDelete;

        return (
          <TableRow
            key={key}
            row={row}
            index={index}
            columns={columns}
            onPress={onRowPress ? () => onRowPress(row, index) : undefined}
            rowActions={rowActions}
            minActionSlots={minActionSlots}
            onEdit={onEdit}
            canEdit={rowCanEdit}
            onDelete={onDelete ? () => onDelete(row, index) : undefined}
            canDelete={rowCanDelete}
            style={computedRowStyle}
            selectable={selectable}
            isSelected={selectedKeys?.has(key)}
            onToggleSelect={(shiftKey) => onToggleSelect?.(key, index, shiftKey)}
            showTooltipWhileEditing={showTooltipWhileEditing}
          />
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  body: {
    flex: 1,
  },
});
